import React, {Component} from "react";
import ContingencyTrustBbvaView from "./ContingencyTrustBbvaView";
import {CatalogContingencyService} from "../../../service/catalog/CatalogContingencyService";
import {ContingencyTrustService} from "../../../service/operation/contingencyTrust/ContingencyTrustService";
import {Button} from "primereact/button";
import {Growl} from "primereact/growl";
import {
    INSTRUCCION_CANCELADA,
    INSTRUCCION_LIQUIDADA_LABEL,
    INSTRUCCION_NO_LIQUIDADA_LABEL,
    INSTRUCCION_ENVIADA,
    INSTRUCTION_TYPE_RECEIVE_ID,
    INSTRUCTION_TYPE_RECEIVE_LABEL,
    INSTRUCTION_TYPE_SEND_ID,
    INSTRUCTION_TYPE_SEND_LABEL, INSTRUCCION_LIQUIDADA, INSTRUCCION_CANCELADA_LABEL,
} from "../../../utils/constants/Constants";
import ConfirmationMessage from "../../../components/confirmationMessage";
import {ReportsService} from "../../../service/reports/ReportsService";
import {CustodyBBVAService} from "../../../service/custody/CustodyBBVAService";

export default class ContingencyTrustBbvaContainer extends Component {
    constructor(props) {
        super(props);

        this.catalogService = new CatalogContingencyService();
        this.custodyService = new CustodyBBVAService();
        this.contingencyTrustService = new ContingencyTrustService();
        this.reportsService = new ReportsService();
        this.confirmationRef = null;
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };
        this.setConfirmationUpdateRef = element => {
            this.confirmationUpdateRef = element
        };

        this.loading = this.loading.bind(this);
        this.getCatInstitution = this.getCatInstitution.bind(this);

        this.state = {
            baseUrl: '',
            isLoading: true,
            manualSettle: false,
            catInstitution: this.getCatInstitution(),
            contingencyInstructions: [],
            folioFilter: '',
            statusContingencyFilter: [],
            catInstitutionFilter: [],
            catInstructionTypeFilter: [],
            catStatusFilter:{statusName: INSTRUCCION_NO_LIQUIDADA_LABEL},
            selectedInstruction: [],
            catInstructionType:[
                {
                    instructionId: INSTRUCTION_TYPE_RECEIVE_ID,
                    instructionName: INSTRUCTION_TYPE_RECEIVE_LABEL
                }, {
                    instructionId: INSTRUCTION_TYPE_SEND_ID,
                    instructionName: INSTRUCTION_TYPE_SEND_LABEL
                }
            ],
            catStatus:[
                {
                    statusName: INSTRUCCION_LIQUIDADA_LABEL
                }, {
                    statusName: INSTRUCCION_NO_LIQUIDADA_LABEL
                },{
                    statusName: INSTRUCCION_CANCELADA_LABEL
                }
            ],
            exportOptions: [
                {
                    label: "Layout BBVA", action: () => {
                        this.openConfirmationMessage("LAYOUT_BBVA")
                    }
                },
                {
                    label: "CSV", action: () => {
                        this.openConfirmationMessage("CSV")
                    }
                },
            ],
            typeDocument: '',
        };
        this.searchContingency = this.searchContingency.bind(this);
        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.selectRowInstruction = this.selectRowInstruction.bind(this);
        this.exportSelection = this.exportSelection.bind(this);
        this.actionSend = this.actionSend.bind(this);
        this.actionAuth =  this.actionAuth.bind(this);
        this.actionSettl = this.actionSettl.bind(this);
        this.actionsTemplate = this.actionsTemplate.bind(this);
        this.errorTemplate =  this.errorTemplate.bind(this);
        this.updateInstitutions = this.updateInstitutions.bind(this);
        this.onChangeSwitch = this.onChangeSwitch.bind(this)
        this.openConfirmationMessage = this.openConfirmationMessage.bind(this);
        this.openConfirmationMessageUpdateInst = this.openConfirmationMessageUpdateInst.bind(this);

        this.searchContingency("FUNCTION");
    }

    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    openConfirmationMessage(docType) {
        if (this.confirmationRef) {
            this.setState({
                typeDocument: docType,
            });
            this.confirmationRef.openConfirmationMessage();
        }
    }

    getCatInstitution() {
        this.loading();
        this.catalogService.getCatInstitutionBbva().then(
            catInstitution =>
                this.setState({
                    catInstitution: catInstitution,
                    isLoading: false
                }))
    }

    searchContingency(stringFlag) {
        this.loading();
        this.contingencyTrustService.getContingencyInstructionsBbva(
            this.state.folioFilter,
            this.state.catInstitutionFilter,
            this.state.catInstructionTypeFilter,
            this.state.catStatusFilter
        ).then(
            res =>{
                if(res.success){
                    if(res.payload === undefined && stringFlag !== "FUNCTION"){
                        this.growl.show({severity: 'info', summary: 'Info.',
                            detail: "No hay datos"});
                    }
                    this.setState({
                        contingencyInstructions: res.payload,
                    })
                }else{
                    this.growl.show({severity: 'error', summary: 'Error.',
                        detail: res.message});
                }
                this.setState({
                    isLoading: false
                })
            }
        )
    }

    onChangeFilter(event) {
        const {name, value} = event.target;
        this.setState({[name]: value,})
    }
    onChangeSwitch(event) {
        const {name, value} = event.target;
        let valueAux = value && this.state.contingencyInstructions.length > 0;
        this.setState({[name]: valueAux,})
    }

    selectRowInstruction(event) {
        this.setState({
            selectedInstruction: event.value
        })
    }

    clearFilters() {
        this.setState({
            folioFilter: '',
            catInstitutionFilter: [],
            catInstructionTypeFilter: [],
            catStatusFilter:[],
        })
    }

    exportSelection() {
        switch (this.state.typeDocument) {
            case "LAYOUT_BBVA":
                if (this.state.selectedInstruction.length === 0){
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: 'Favor de seleccionar al menos una garantía a exportar.'
                    });
                } else {
                    this.loading();
                    let idList = [];
                    this.state.selectedInstruction.map(instruction => idList.push(instruction.id))
                    let params = {idList: idList.toString()}
                    this.contingencyTrustService.getContingencyLayoutTXT(params).then(response => {
                        this.setState({
                            isLoading: false,
                            selectedInstruction: [],
                        });
                    });
                }
                break;
            case "CSV":
                if (this.state.contingencyInstructions === undefined || this.state.contingencyInstructions.length === 0){
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: 'No hay datos a exportar.'
                    });
                } else {
                    this.loading();
                    let params = {
                        loanId: this.state.folioFilter ? this.state.folioFilter : 0,
                        counterpartId: this.state.catInstitutionFilter.institutionId ? this.state.catInstitutionFilter.institutionId : 0,
                        eventType: this.state.catInstructionTypeFilter.instructionId ? this.state.catInstructionTypeFilter.instructionId : "",
                        status: this.state.catStatusFilter.statusName ? this.state.catStatusFilter.statusName : "",
                    }
                    this.reportsService.getInstructionsReportCSV(params).then(resp =>{
                        this.setState({
                            isLoading: false,
                        });
                    });
                }
                break;
            default:
                break;
        }
    }
    actionsTemplate(rowData, column){
        let rowStatus = rowData.status.toUpperCase();
        let rowRefBBVA = rowData.trustReference;
        if (rowStatus.toUpperCase() !== INSTRUCCION_LIQUIDADA && rowStatus.toUpperCase() !== INSTRUCCION_CANCELADA){
            if (rowRefBBVA === "" || rowRefBBVA === undefined){
                return <div>
                    <Button type="button" label={"Reenviar"} onClick={()=>this.actionSend(rowData)} style={{marginBottom: '.5em', marginTop:'.5em'}}
                            className={this.state.manualSettle ? "p-button-secondary" : ""}/><br/>
                    {this.state.manualSettle ?
                        <Button type="button" label={"Liquidar"} onClick={()=>this.actionSettl(rowData)} style={{marginBottom: '.5em'}}/> : ""}
                </div>;
            }else{
                if (rowStatus.startsWith("ERROR") || INSTRUCCION_ENVIADA === rowStatus ||
                    (rowData.trustMessage !== undefined && rowData.trustMessage !== null && rowData.trustMessage !== '' && rowData.status === 'CAPTURADA')){
                    return <div>
                        <Button type="button" label={"Autorizar"} onClick={()=>this.actionAuth(rowData)}style={{marginBottom: '.5em', marginTop:'.5em'}}
                                className={this.state.manualSettle ? "p-button-secondary" : ""}/><br/>
                        {this.state.manualSettle ?
                            <Button type="button" label={"Liquidar"} onClick={()=>this.actionSettl(rowData)} style={{marginBottom: '.5em'}}/> : ""}
                    </div>
                }else {
                    return <Button type="button" label={"Liquidar"} style={{marginTop:'.5em', marginBottom: '.5em'}} onClick={()=>this.actionSettl(rowData)}/> ;
                }
            }
        }
    }
    errorTemplate(rowData, column){
        if (rowData.status.startsWith("Error")){
            return (
                <div>Error &nbsp; &nbsp;&nbsp; &nbsp;
                    <Button icon="pi pi-bell" className="p-button-rounded p-button-secondary" tooltip={rowData.status} />
                </div>);
        }else if(rowData.trustMessage !== undefined && rowData.trustMessage !== null && rowData.trustMessage !== '' && rowData.status === 'CAPTURADA'){
            return (
                <div>{rowData.status} &nbsp; &nbsp;&nbsp; &nbsp;
                    <Button icon="pi pi-bell" className="p-button-rounded p-button-secondary" tooltip={rowData.trustMessage} />
                </div>);
        }else {
            return (<div> {rowData.status} </div>);
        }

    }
    actionSend(rowData){
        this.loading();
        this.contingencyTrustService.sendInstruction(rowData.referencePv).then(response => {
            if(response.success){
                this.growl.show({severity: 'success', summary: 'Éxito.',
                    detail: 'Se ha actualizado correctamente su solicitud.'});
                this.searchContingency("FUNCTION");
            }else{
                this.growl.show({severity: 'error', summary: 'Error.',
                    detail: response.message});
            }
            this.setState({
                isLoading: false
            });
        });
    }
    actionAuth(rowData){
        this.loading();
        this.contingencyTrustService.sendAuthInstruction(rowData.referencePv).then(response => {
            if(response.success){
                this.growl.show({severity: 'success', summary: 'Éxito.',
                    detail: 'Se ha actualizado correctamente su solicitud.'});
                this.searchContingency("FUNCTION");
            }else{
                this.growl.show({severity: 'error', summary: 'Error.',
                    detail: response.message});
            }
            this.setState({
                isLoading: false
            });
        });
    }
    actionSettl(rowData){
        this.loading();
        let username = localStorage.getItem('username');
        this.contingencyTrustService.sendSettleInstruction(rowData.referencePv, username).then(response => {
            if(response.success){
                 this.growl.show({severity: 'success', summary: 'Éxito.',
                    detail: 'Se ha actualizado correctamente su solicitud.'});
                this.searchContingency("FUNCTION");
            }else{
                this.growl.show({severity: 'error', summary: 'Error.',
                    detail: response.message});
            }
            this.setState({
                isLoading: false
            });
        });
    }

    openConfirmationMessageUpdateInst() {
        if (this.confirmationUpdateRef) {
            this.custodyService.getCustodyData().then(res => {
                if(res.success){
                    this.setState({
                        baseUrl: res.payload.baseUrl,
                    });
                    this.confirmationUpdateRef.openConfirmationMessage();
                }else{
                    this.growl.show({severity: 'error', summary: 'Error.',
                        detail: res.message});
                }
            });
        }
    }

    updateInstitutions(){
        this.loading();
        this.contingencyTrustService.updateInstitutions().then(response => {
          this.setState({
                isLoading: false
            });
            if(response.success){
                this.growl.show({severity: 'success', summary: 'Éxito.',
                    detail: 'Se ha actualizado correctamente su solicitud.'});
            }else{
                this.growl.show({severity: 'error', summary: 'Error.',
                    detail: response.message});
            }
        });
    }


    render() {
        let confMsgUpdateInst = <ConfirmationMessage ref={this.setConfirmationUpdateRef}
                                           invisible={true}
                                           legend={"¿Está seguro de actualizar las instituciones con \"" + this.state.baseUrl + "\" ?"}
                                           action={this.updateInstitutions}/>;
        let confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                           invisible={true}
                                           legend="¿Está seguro de continuar descargando la información solicitada?"
                                           action={this.exportSelection}/>;
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {
            catInstitution, catInstructionType, catStatus, contingencyInstructions,
            statusContingencyFilter, catInstitutionFilter, catInstructionTypeFilter,
            folioFilter, catStatusFilter, selectedInstruction, manualSettle, exportOptions
        } = this.state;

        return (
            <ContingencyTrustBbvaView
                messagesGrowl={messagesGrowl}
                catInstitution={catInstitution}
                catInstructionType={catInstructionType}
                catStatus={catStatus}
                contingencyInstructions={contingencyInstructions}
                folioFilter={folioFilter}
                statusContingencyFilter={statusContingencyFilter}
                catInstitutionFilter={catInstitutionFilter}
                catInstructionTypeFilter={catInstructionTypeFilter}
                catStatusFilter={catStatusFilter}
                selectedInstruction={selectedInstruction}
                manualSettle={manualSettle}
                exportOptions={exportOptions}
                confMsg={confMsg}
                confMsgUpdateInst={confMsgUpdateInst}

                isLoading={this.state.isLoading}
                searchContingency={this.searchContingency}
                onChangeFilter={this.onChangeFilter}
                clearFilters={this.clearFilters}
                selectRowInstruction={this.selectRowInstruction}
                exportSelection={this.exportSelection}
                actionsTemplate={this.actionsTemplate}
                errorTemplate={this.errorTemplate}
                onChangeSwitch={this.onChangeSwitch}
                openConfirmationMessageUpdateInst={this.openConfirmationMessageUpdateInst}
            />)
    }
};